import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { SearchRequestDto, ProductsService, SearchRequestFilterStateDto, FilterDescriptionDto, FacetOptionDto  } from "./api";

export class ProductSearchComponent extends AlpineComponent {
    collectionId: string;
    filterDescriptions: Array<FilterDescriptionDto> = [];
    filterStates: Array<SearchRequestFilterStateDto> = [];    
    searchDebounceTimeout: NodeJS.Timeout | null = null;
    isLoading: Boolean = false;
    resultsHtml = "";

    constructor(collectionId: string, filterDescriptions: Array<FilterDescriptionDto>, initialGridHtml: string = "") {
        super();
        this.collectionId = collectionId;
        this.filterDescriptions = filterDescriptions;
        this.filterStates = this.filterDescriptions.map((filter) => {
            return {                
                filterAlias: filter.fieldAlias,
                selectedFacetOptions: []
            };
        });
        this.resultsHtml = initialGridHtml;
    }
    init(): void {
        console.log("init");
    }

    async search() {
        const requestBody: SearchRequestDto = {
            collectionId: this.collectionId,
            filters: this.filterStates,
            page: 1,
            resultsPerPage: 10,
            sortBy: "relevance"                
        };

        const { data, error } = await ProductsService.postProductsSearch({
            body: requestBody
        });
        
        if(error) {
            console.error("Error fetching search results:", error);
            this.isLoading = false;
            return;
        }

        if(!data) {
            console.error("No data received from search service.");
            this.isLoading = false;
            return;
        }

        this.resultsHtml = data.productGridHtml;
    }

    async toggleFilterValue(filter: FilterDescriptionDto, filterOption: FacetOptionDto | undefined, filterValue : string | undefined) {
        if (this.searchDebounceTimeout != null) {
            clearTimeout(this.searchDebounceTimeout);
        }
        this.isLoading = true;


        let filterState = this.filterStates.find((f)=>f.filterAlias === filter.fieldAlias);
        if (!filterState) {
            this.isLoading = false;
            console.error("Filter state not found for alias:", filter.fieldAlias);
            return;
        }

        if(filter.isFaceted && filterOption) {
            const index = filterState.selectedFacetOptions.indexOf(filterOption);
            if( index > -1) {
                filterState.selectedFacetOptions.splice(index, 1);
            } else {
                filterState.selectedFacetOptions.push(filterOption);
            }
        } else if(filterValue) {
            filterState.simpleFilterValue = filterValue;
        }

        this.searchDebounceTimeout = setTimeout(this.search.bind(this), 1000);
    }

    isFacetValueSelected(filter: FilterDescriptionDto, filterOption: FacetOptionDto) {
        let filterState = this.filterStates.find((f) => f.filterAlias === filter.fieldAlias);
        if (!filterState) {
            return false;
        }
        
        return filterState.selectedFacetOptions.indexOf(filterOption) > -1;
    }
};